import './Button.scss';

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default class Button extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        disabled: PropTypes.bool,
        onClick: PropTypes.func,
        noStyles: PropTypes.bool,
        size: PropTypes.string,
        type: PropTypes.string
    };

    render() {
        let { className, noStyles, size, type, ...otherProps } = this.props;
        return (
            <button {...otherProps}
                    type={type || 'button'}
                    className={classNames('c-button', className, {
                        'a-button--no-styles': noStyles === true,
                        'a-button--small': size === 'small'
                    })}>
                {this.props.children}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Button/index.js